export default "__VITE_ASSET__8381e7ae__"